import React from 'react';
import {
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material';
import { formatDateDisplay } from '../../utils/dateUtils';

// VetCheckupItemsDialog — حوار «عناصر الجولة» مستخرَج من VetCheckupReport (تفكيك، 3.4.42).
// عرض بحت بلا حالة: يستقبل الجولة المختارة + onClose + t — نفس السلوك السابق حرفيًّا.
export default function VetCheckupItemsDialog({ itemsOfRound, onClose, t }) {
  return (
    <Dialog open={!!itemsOfRound} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        {t('vetReport.itemsOfRound', 'عناصر الجولة')} — #
        {itemsOfRound?.round?.round_id}
      </DialogTitle>
      <DialogContent dividers>
        {!itemsOfRound ||
        !Array.isArray(itemsOfRound.items) ||
        itemsOfRound.items.length === 0 ? (
          <Alert severity="info" sx={{ my: 1 }}>
            {t('vetReport.noItems', 'لا توجد عناصر مرتبطة بهذه الجولة')}
          </Alert>
        ) : (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>#</TableCell>
                <TableCell>{t('vetReport.horse', 'الخيل')}</TableCell>
                <TableCell>{t('vetReport.case', 'الحالة')}</TableCell>
                <TableCell>{t('vetCheckup.severity', 'الشدة')}</TableCell>
                <TableCell>
                  {t('vetReport.actionRequired', 'يتطلب إجراء')}
                </TableCell>
                <TableCell>{t('vetReport.followUp', 'متابعة')}</TableCell>
                <TableCell>
                  {t('vetReport.itemNotes', 'ملاحظات الحالة')}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {itemsOfRound.items.map((it) => (
                <TableRow
                  key={it.item_id || `${it.horse_id}-${it.type_id}`}
                >
                  <TableCell>{it.item_id || '—'}</TableCell>
                  <TableCell>
                    {it.horse_name ||
                      it.horse_name_ar ||
                      it.horse_name_en ||
                      it.horse ||
                      it.horse_id}
                  </TableCell>
                  <TableCell>
                    {it.type_name_ar || it.type_name_en || it.type_id}
                  </TableCell>
                  <TableCell>{it.severity || 'low'}</TableCell>
                  <TableCell>
                    {Number(it.action_required)
                      ? t('common.yes', 'نعم')
                      : t('common.no', 'لا')}
                  </TableCell>
                  <TableCell>{it.follow_up_date ? <span className="date-ltr">{formatDateDisplay(it.follow_up_date)}</span> : '—'}</TableCell>
                  <TableCell
                    sx={{
                      maxWidth: 360,
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {it.notes || '—'}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </DialogContent>
    </Dialog>
  );
}
